module.exports = __webpack_public_path__ + "static/partnershipImg-a95e2db65887383366b4e778b7bd6c12.jpg";